// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8fb439f1","453":"0d649a2e","455":"53f403de"}[chunkId] + ".chunk.js";
};